import useRequestMutation from 'hooks/client/useMutation';
import type { MutationResponse, RequestTypes } from 'hooks/types/client';

export type UpsertInvestigationBody = {
  name: string;
  description?: string;
  discover_id?: string;
};

type UseUpsertInvestigation = () => Omit<
  MutationResponse<'investigations.upsert'>,
  'mutate' | 'mutateAsync'
> & {
  mutateAsync: (data: UpsertInvestigationBody) => Promise<RequestTypes['investigations.upsert']>;
};

const useUpsertInvestigation: UseUpsertInvestigation = () => {
  const { mutateAsync: mutateAsyncBase, ...rest } = useRequestMutation('investigations.upsert', {
    invalidate: [['investigations.list']],
    successAlert: 'Investigation created',
  });

  return {
    ...rest,
    mutateAsync: (data) => mutateAsyncBase({ data }),
  };
};

export default useUpsertInvestigation;
